let defaults = {
  globalSpinnerText: "core.loading",
};

export default {
  state: () => ({
    isPageMounted: false,
  }),
  mutations: {
    setIsPageMounted(state, payload) {
        state.isPageMounted = payload;
    },
  },
  actions: {},
  getters: {
    isPageMounted(state) {
      return state.isPageMounted;
    },
  },
};
